import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#3b82f6',
        colorInfo: '#3b82f6',
        colorSuccess: '#059669',
        colorWarning: '#f59e0b',
        colorError: '#f43f5e',
        borderRadius: 10,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        colorLink: '#3b82f6',
        colorLinkHover: '#2563eb',
        colorLinkActive: '#1d4ed8',
        fontSize: 14,
        fontSizeHeading1: 38,
        fontSizeHeading2: 30,
        fontSizeHeading3: 24,
        fontSizeHeading4: 20,
        fontSizeHeading5: 16,
        lineHeight: 1.6,
        controlHeight: 40,
        wireframe: false,
      },
      components: {
        Segmented: {
          itemSelectedBg: "#eff6ff",
          itemSelectedColor: "#1d4ed8",
          borderRadius: 10,
        },
        Menu: {
          itemBg: 'transparent',
          itemSelectedBg: 'rgba(255,255,255,0.15)',
          itemHoverBg: 'rgba(255,255,255,0.08)',
          horizontalItemSelectedColor: '#ffffff',
          horizontalItemHoverColor: 'rgba(255,255,255,0.85)',
          itemColor: 'rgba(255,255,255,0.7)',
          fontSize: 14,
        },
        Card: {
          borderRadiusLG: 16,
        },
        Button: {
          borderRadius: 10,
          controlHeight: 40,
          fontWeight: 500,
        },
        Table: {
          borderRadius: 16,
          headerBg: '#f8fafc',
          headerColor: '#334155',
          rowHoverBg: '#eff6ff',
        },
        Select: {
          borderRadius: 10,
          optionSelectedBg: '#eff6ff',
        },
        Input: {
          borderRadius: 10,
        },
        InputNumber: {
          borderRadius: 10,
        },
        Modal: {
          borderRadiusLG: 16,
        },
        Notification: {
          borderRadiusLG: 16,
        },
        Message: {
          borderRadiusLG: 10,
        },
        Tag: {
          borderRadiusSM: 6,
        },
      },
    }}
  >
    <App />
  </ConfigProvider>
);

reportWebVitals();
